import axios from "axios";
import { setAccessToken, setCsrfToken, setRefreshToken } from "../tokenStore";

const BASE_URL = process.env.REACT_APP_BASE_URL;

/**
 * Step 1 — Request OTP
 * Sends an OTP to the given identifier (phone or email)
 * For new users, first_name and last_name are optional
 * @param {{ identifier: string, first_name?: string, last_name?: string }} payload
 */
export const requestOtp = async ({ identifier, first_name, last_name }) => {
  try {
    const response = await axios.post(
      `${BASE_URL}/web-auth/request-otp`,
      { identifier, first_name, last_name },
      { withCredentials: true }
    );
    return response.data;
  } catch (error) {
    const message = error.response?.data?.message || error.message || "Failed to send OTP";
    throw new Error(message);
  }
};

/**
 * Step 2 — Verify OTP and complete login
 * No device_id needed — backend manages web sessions automatically
 * On success stores accessToken (memory), refreshToken (localStorage), csrfToken (memory)
 * @param {{ identifier: string, otp: string }} payload
 * @returns {{ status, success, message, data: { accessToken, refreshToken, csrfToken, user } }}
 */
export const verifyOtp = async ({ identifier, otp }) => {
  try {
    const response = await axios.post(
      `${BASE_URL}/web-auth/verify-otp`,
      { identifier, otp },
      { withCredentials: true }
    );

    const result = response.data;

    if (result?.data?.accessToken) {
      setAccessToken(result.data.accessToken);
      setCsrfToken(result.data.csrfToken || "");
      setRefreshToken(result.data.refreshToken);
    }

    return result;
  } catch (error) {
    const message = error.response?.data?.message || error.message || "OTP verification failed";
    throw new Error(message);
  }
};
